import type { OperatorConfigurationState } from '@/lib/operator-config/types'

export type SetupWizardStepId =
  | 'business'
  | 'services'
  | 'coverage'
  | 'availability'
  | 'integrations'

export const SETUP_WIZARD_STEP_ORDER: SetupWizardStepId[] = [
  'business',
  'coverage',
  'availability',
  'services',
  'integrations',
]

type SetupWizardNextActionInput = {
  step: SetupWizardStepId
  canAdvance: boolean
  isLastStep: boolean
}

export function getSetupWizardNextAction(input: SetupWizardNextActionInput): {
  label: string
  disabled: boolean
} {
  if (input.step === 'integrations') {
    return { label: 'Save & Explore', disabled: false }
  }

  if (
    input.step === 'business' ||
    input.step === 'coverage' ||
    input.step === 'availability' ||
    input.step === 'services'
  ) {
    return {
      label: 'Continue',
      disabled: false,
    }
  }

  return {
    label: input.isLastStep ? 'Save & Explore' : 'Continue',
    disabled: false,
  }
}

export function getInitialSetupWizardStep(
  configuration: OperatorConfigurationState
): SetupWizardStepId {
  const hasBusinessStep = Boolean(
    configuration.operator?.businessName && configuration.operator?.slug
  )
  const hasServicesStep = configuration.services.some((service) => service.isActive)
  const hasCoverageStep = Boolean(
    configuration.serviceArea?.centerLat && configuration.serviceArea?.centerLng
  )
  const hasAvailabilityStep = configuration.slots.length > 0

  if (!hasBusinessStep) return 'business'
  if (!hasCoverageStep) return 'coverage'
  if (!hasAvailabilityStep) return 'availability'
  if (!hasServicesStep) return 'services'

  return 'integrations'
}
